import * as _ from 'lodash';
import * as uuid from '@lgce/uuid-utils';
import { Intervention } from './intervention.class';
import { Maintenance } from './maintenance.class';
import { Issue } from './issue.class';

export class Station {
  public id?: string;
  public ref: string;
  public line: string;
  public name: string;
  public contact: string;
  public tel: string;
  public description: string;
  public equipments: any[];
  public comment: string;
  public Interventions?: Intervention[];
  public Maintenances?: Maintenance[];
  public Issues?: Issue[];

  static get equipmentTypes(): any[] {
    return [
      { key: 'POMPE', label: 'Pompe', max: 3 },
      { key: 'AGITATEUR', label: 'Agitateur', max: 1 },
      { key: 'VARIATEUR', label: 'Variateur', max: 1 },
      { key: 'ANTI-BELIER', label: 'Anti-bélier', max: 1 },
      { key: 'POTENCE', label: 'Potence', max: 1 },
    ];
  }

  constructor(obj?: any) {
    const data = {
      ...(obj || {})
    };

    this.id = data.id;
    this.ref = data.ref;
    this.line = data.line;
    this.name = data.name;
    this.description = data.description;
    this.equipments = data.equipments || [];
    this.contact = data.contact;
    this.tel = data.tel;
    this.description = data.description;
    this.comment = data.comment;

    if (data.Interventions) {
      this.Interventions = data.Interventions
        .map((intervention) => new Intervention(intervention));
    }

    if (data.Maintenances) {
      this.Maintenances = data.Maintenances
        .map((maintenance) => new Maintenance(maintenance));
    }

    if (data.Issues) {
      this.Issues = data.Issues
        .map((issue) => new Issue(issue));
    }
  }

  public groupEquipmentsByType() {
    for (const equipment of this.equipments) {
      equipment._uuid = uuid();
    }

    const equipmentsByType = _.groupBy(this.equipments, '_type');

    for (const type of Station.equipmentTypes) {
      if (!(type.key in equipmentsByType)) {
        equipmentsByType[type.key] = [];
      }
    }

    return equipmentsByType;
  }

  public getEquipment(type: string, idxOfType: number = 0) {
    let idxEquip = -1;
    return this.equipments.find((equip) => {
      if (equip._type !== type) return false;
      idxEquip++;
      return idxEquip === idxOfType;
    });
  }

  public toJSON() {
    return {
      id: this.id,
      ref: this.ref,
      line: this.line,
      name: this.name,
      description: this.description,
      contact: this.contact,
      tel: this.tel,
      equipments: this.equipments,
      comment: this.comment,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/models/station.class.ts